import { CheckboxProps, SvgIconProps } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import _get from 'lodash/get';
import React, { CSSProperties } from 'react';
import colors from 'src/utils/colors';

interface StyledCheckboxProps {
  InnerIcon: React.ComponentType<SvgIconProps>;
  OuterIcon?: React.ComponentType<SvgIconProps>;
  checkboxProps: CheckboxProps;
  styleObj?: CSSProperties & {
    iconBackgroundColor?: string;
    iconColor?: string;
    checkedIconBackgroundColor?: string;
    checkedIconColor?: string;
  };
}

export default function StyledCheckbox({ InnerIcon, checkboxProps, styleObj = {}, OuterIcon }: StyledCheckboxProps) {
  const width = _get(styleObj, 'width', 14);
  const height = _get(styleObj, 'height', 14);
  const iconBackgroundColor = _get(styleObj, 'iconBackgroundColor', colors.borderGrey);
  const iconColor = _get(styleObj, 'iconColor', colors.darkBlue);
  const checkedIconBackgroundColor = _get(styleObj, 'checkedIconBackgroundColor', colors.darkBlue);
  const checkedIconColor = _get(styleObj, 'checkedIconColor', colors.borderGrey);
  const paddingRight = _get(styleObj, 'paddingRight', '9px');

  const baseIconStyle = {
    width,
    height,
    backgroundColor: iconBackgroundColor,
    color: iconColor
  };

  return (
    <Checkbox
      sx={{
        paddingRight,
        padding: styleObj.padding,
        '&:hover': {
          backgroundColor: 'transparent'
        }
      }}
      disableRipple
      color="default"
      checkedIcon={
        <InnerIcon
          style={{
            ...baseIconStyle,
            color: checkedIconColor,
            backgroundColor: checkedIconBackgroundColor
          }}
        />
      }
      icon={<OuterIcon style={baseIconStyle} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...checkboxProps}
    />
  );
}
